<template>
  <div class="modal-sidebar__cats">
    <a href="javascript:;" class="font-size-16 font-sanpro primary-color" @click="handleBackBookList">
      <span class="icon-arrow-left primary-color font-size-12"><span class="path1 priamry-color"></span><span class="path2 priamry-color"></span></span> 
      Trở lại
    </a>
      </div>
</template>
<script>

import { mapState, mapActions } from 'vuex'
import { STORE_KEY } from './../../_store/constants'
export default {
    data () {
        return {

        }
    },
    computed: {
    ...mapState(STORE_KEY, ['chapterIdQuestion', 'paramsGetQuestionsSample', 'paramFilterQuestionsByChapter'])
    },
    methods: {
        ...mapActions(STORE_KEY, ['acSetChapterIdQuestions', 'acSetParamsFilterQuestionChapter', 'acSetQuestionSample']),
        handleBackBookList () {
        this.acSetParamsFilterQuestionChapter({...this.paramFilterQuestionsByChapter, examId: 0})
        },
    }
}
</script>